<template>
  <div
    v-if="visitedViews.length"
    class="tags-view-container"
    :style="tagsViewStyle"
  >
    <scroll-pane
      ref="scrollPane"
      class="tags-view-wrapper"
    >
<!--
:style="getLinkStyle(tag)"
-->
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :class="isActive(tag)?'active':''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        :key="tag.path"
        tag="span"
        class="tags-view-item"
        @click.middle.native="closeSelectedTag(tag)"
        @contextmenu.prevent.native="openMenu(tag,$event)">
        {{ tag.title }}
        <span class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>
    <ul
      v-show="visible"
      :style="{left:left+'px',top:top+'px'}"
      class="contextmenu"
    >
      <li
        class="contextmenu-li"
        @click="closeSelectedTag(selectedTag)">关闭当前标签页</li>
      <li
        class="contextmenu-li"
        @click="closeOthersTags">关闭其他标签页</li>
      <li
        class="contextmenu-li"
        @click="closeAllTags">关闭所有标签页</li>
      <li
        class="contextmenu-li"
        @click="refreshSelectedTag(selectedTag)">刷新当前标签页</li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ScrollPane from '@/components/ScrollPane'

export default {
  components: {
    ScrollPane
  },
  props: {
    rapperWith: {
    },
  },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {}
    }
  },
  computed: {
    ...mapGetters(['themeColor','verticalNavMenuItemsMin','device','verticalNavMenuWidth','isVerticalNavMenuActive','reduceButton']),
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    tagsViewStyle(){
      /*return {
        width: this.rapperWith + 'px',
      }*/
      // 侧边栏收起的时候
      if(this.device == 'mobile'){
        return {
          width: '100%'
        }
      }else {
        // 需要更加准确
        if(this.verticalNavMenuItemsMin || this.reduceButton){
          //鼠标移到侧边栏上面然后移开之后才成立,
          return {
            width: 'calc(100% - 80px)'
          }

        }else if(!this.verticalNavMenuItemsMin) {
          return {
            width: 'calc(100% - 260px)'
          }
        }
      }
    },
  },
  watch: {
    $route() {
      this.addViewTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.addViewTags()
  },
  methods: {
    getLinkStyle(tag){
      if(tag.path === this.$route.path){
        return {
          // backgroundColor: this.themeColor,
          // color: '#fff',
          borderColor: this.themeColor,
        }
      }
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
    addViewTags() {
      const { name } = this.$route;
      if (name && name !== 'home') {
        this.$store.dispatch('addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      this.$nextTick(() => {
        const tags = this.$refs.tag || [];
        for (const tag of tags) {
          /*console.log('tagView的path',tag.to.path);
          console.log('tagView的$route.path',this.$route.path);*/
          let handleUrl = tag.to.path;
          if (handleUrl === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)

            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('updateVisitedView', this.$route)
            }

            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          // todo
          this.$router.replace({
            path: fullPath
          })
        })
      })
    },
    closeSelectedTag(view) {
      this.$store.dispatch('delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          const latestView = visitedViews.slice(-1)[0]
          if (latestView) {
            this.$router.push(latestView)
          } else {
            this.$router.push('/')
          }
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags() {
      this.$store.dispatch('delAllViews')
      this.$router.push('/')
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }
      this.top = e.clientY - 20;//上去20px

      this.visible = true
      this.selectedTag = tag;
    },
    closeMenu() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variable";
.tags-view-container {
  position: fixed;
  top: 60px;
  z-index: 999;
  height: 44px;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      z-index: 999;
      cursor: pointer;
      height: 36px;
      line-height: 36px;//跟上面相差8px

      color: #495060;
      background: #fff;
      //padding: 0 8px;
      font-size: 14px;
      margin-left: 15px;
      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        border-bottom: 2px solid $themeColor;
        color: $themeColor;
        /*&::before {
          content: '';
          background: #fff;
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 2px;
        }*/
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 100;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    .contextmenu-li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #EFF3FF;
        color: $themeColor;
      }
    }
  }
}

</style>

<style lang="scss">
@import "../../assets/scss/variable";
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      font-size: 18px;
      //vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;
      &:before {
        transform: scale(.6);
        display: inline-block;
        vertical-align: -3px;
      }
      &:hover {
        //background-color: #b4bccc;
        color: $themeColor;
      }
    }
  }
  .el-scrollbar__thumb:hover {
    //background-color: rgba(144, 147, 153, .5);
  }
}
</style>
